import { css } from 'linaria';

export const header = css`
  && {
    margin-bottom: 16px;

    @media (--only-largeDesktop) {
      margin-bottom: 32px;
    }

    @media (--only-mobile) {
      margin-bottom: 12px;
    }
  }
`;

export const headerTitle = css`
  margin-bottom: 16px;

  @media (--only-mobile) {
    margin-bottom: 12px;
  }
`;

export const headerMedia = css`
  border-radius: var(--rounding-xl);
  object-fit: cover;
  height: 454px;

  @media (--only-mobile) {
    height: 450px;
  }
`;
